import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';

import { DataFlowColumn } from '../dataset/dataflowcolumn';
import { BaseSchemaGeneratorTransformation } from './base-schema-generator-transformation';

@Metamodel.model({
    name: 'extend',
    display: [stringResources.DataFlowExtendTransformationLabel, stringResources.DataFlowExtendTransformationsLabel],
    referable: true,
    constraints: {
        name: {
            required: true
        },
        method: {
            required: true
        }
    }
})
export class ExtendTransformation extends BaseSchemaGeneratorTransformation {
    public static readonly MODEL: IModel;

    public method: string = '';

    protected _outputColumns(): DataFlowColumn[] {
        return this.columns;
    }

    protected getGeneratedDescription(): string {
        return stringResources.ExtendTransformationDescription;
    }
}
